import { buildUrl } from '../utils/apiUtils';
import api from './api';

const { authApi, storageApi, coreApi } = api;

const API = {
  LOGIN: '/login',
  REGISTER: '/register',
  USER_INFO: '/user-info',
  VERIFY_2FA: '/verify-2fa-token',
  LOG_OUT: '/logout',
  GET_2FA: '/get-2fa-qrcode',
  GET_2FA_CODE: '/get-2fa-secret',
  ENABLE_2FA: '/enable-2fa',
  DISABLE_2FA: '/disable-2fa',
  CHANGE_PASSWORD: '/password',
  VERIFY_EMAIL: '/register-verify',
  UPDATE_AVATAR: '/avatar',

  SEARCH_AUTHORIZATION: '/admin/authorizations',
  AUTHORIZATION: '/admin/authorization',
  ADMIN_USER: '/admin/users',

  PROJECT: '/dcs',
  SEND_PROJECT: '/dcs/send-approve',
  SEND_REJECT: '/dcs/reject',
  SEND_APPROVE: '/dcs/approve',
  HISTORY: '/dcs/history',
};

const createNewProject = (body) => {
  return coreApi.post(API.PROJECT, body);
};

const updateProject = (body) => {
  return coreApi.put(API.PROJECT, body);
};

const sendApprove = (body) => {
  return coreApi.post(API.SEND_PROJECT, body);
};

const getDetail = (id) => {
  return coreApi.get(API.PROJECT + '/' + id);
};

const getDetailReviewer = (id) => {
  return coreApi.get(API.PROJECT + '/review/' + id);
};

const fetchProject = (params = {}) => {
  return coreApi.get(buildUrl(API.PROJECT + '/search', params));
};

const fetchProjectApprove = (params = {}) => {
  return coreApi.get(buildUrl(API.PROJECT + '/search/approve', params));
};

const rejectProject = (body) => {
  return coreApi.post(API.SEND_REJECT, body);
};

const approveProject = (id) => {
  return coreApi.post(API.SEND_APPROVE + '/' + id);
};

const fetchHistory = (params = {}) => {
  return coreApi.get(buildUrl(API.HISTORY, params));
};

const getShareInfo = (dcsId) => {
  return coreApi.get(API.PROJECT + '/share/' + dcsId);
};

const updateShareInfo = (body) => {
  return coreApi.post(API.PROJECT + '/share', body);
};

const pauseDCS = (body) => {
  return coreApi.post(API.PROJECT + '/pause', body)
}

const resumeDCS = (body) => {
  return coreApi.post(API.PROJECT + '/resume', body)
}

// Auth
const changePass = (body) => {
  return authApi.put(API.CHANGE_PASSWORD, body);
};

const login = (username, password) => {
  return authApi.post(API.LOGIN, { username, password });
};

const register = (body) => {
  return authApi.post(API.REGISTER, body);
};

const getUserInfo = () => {
  return authApi.get(API.USER_INFO);
};

const logOut = () => {
  return authApi.post(API.LOG_OUT);
};

const verifyTwoFa = (body) => {
  return authApi.post(API.VERIFY_2FA, body);
};

const getQrCodeAuthen2Fa = () => {
  return authApi.get(API.GET_2FA, { responseType: 'blob' });
};

const getSecret2FaCode = () => {
  return authApi.get(API.GET_2FA_CODE);
};

const getAllAuthorization = (params) => {
  return authApi.get(buildUrl(API.SEARCH_AUTHORIZATION, params));
};

const createNewAuthorization = (body) => {
  return authApi.post(API.AUTHORIZATION, body);
};

const updateAuthorization = (body) => {
  return authApi.put(API.AUTHORIZATION, body);
};

const getAuthorization = (id) => {
  return authApi.get(`${API.AUTHORIZATION}/${id}`);
};

const updateUserInfo = (body) => {
  return authApi.put(API.USER_INFO, body);
};

const adminGetAllUser = (params) => {
  return authApi.get(buildUrl(API.ADMIN_USER, params));
};

const adminCreateUserInternal = (body) => {
  return authApi.post(`${API.ADMIN_USER}/create`, body);
};

const adminUpdateUser = (body) => {
  return authApi.put(`${API.ADMIN_USER}/update`, body);
};

const adminGetDetailUser = (userId) => {
  return authApi.get(`${API.ADMIN_USER}/${userId}`);
};

const adminActiveDeactiveUser = (userId, disable) => {
  return authApi.put(`${API.ADMIN_USER}/${userId}/${disable}`);
};

const verifyRegisterEmail = (body) => {
  return authApi.post(API.VERIFY_EMAIL, body);
};

const enable2FaAuthentication = (body) => {
  return authApi.put(API.ENABLE_2FA, body);
};

const disable2FaAuthentication = (body) => {
  return authApi.put(API.DISABLE_2FA, body);
};

const updateAvatar = (avatarId) => {
  return authApi.post(`/avatar/${avatarId}`);
};

const oauthGoogleAPI = (idToken) => {
  return authApi.post('/oauth-google', idToken);
};

const fortgotPassword = (email) => {
  const form = new FormData();
  form.append('email', email);
  console.log(form, email);
  return authApi.post('/password/forgot', form);
};

const getApiKey = () => {
  return authApi.get('/business-key');
};

const regenerateKey = () => {
  return authApi.put('/business-key');
};

const resetPassword = (body) => {
  return authApi.post('/password/reset', body);
};

// storage

const uploadFile = (bucket, file) => {
  const form = new FormData();
  form.append('file', file);
  return storageApi.post(`/${bucket}`, form);
};

const appApi = {
  login,
  register,
  logOut,
  getUserInfo,
  verifyTwoFa,
  getQrCodeAuthen2Fa,
  getSecret2FaCode,
  enable2FaAuthentication,
  disable2FaAuthentication,
  getAllAuthorization,
  createNewAuthorization,
  updateAuthorization,
  getAuthorization,
  updateUserInfo,
  adminGetAllUser,
  adminGetDetailUser,
  adminCreateUserInternal,
  adminUpdateUser,
  adminActiveDeactiveUser,
  changePass,
  verifyRegisterEmail,
  updateAvatar,
  fortgotPassword,
  resetPassword,
  getApiKey,
  regenerateKey,
  pauseDCS,
  resumeDCS,
  getDetailReviewer,

  uploadFile,

  createNewProject,
  updateProject,
  sendApprove,
  getDetail,
  fetchProject,
  fetchProjectApprove,
  rejectProject,
  approveProject,
  fetchHistory,
  getShareInfo,
  updateShareInfo,
  oauthGoogleAPI
};

export default appApi;
